type ToggleSwitchProps = {
  checked: boolean;
  onChange: () => void;
  label: string;
  disabled?: boolean;
};

export default function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled = false,
}: ToggleSwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={onChange}
      disabled={disabled}
      style={{
        position: "relative",
        width: "40px",
        height: "22px",
        borderRadius: "999px",
        border: "none",
        padding: 0,
        cursor: disabled ? "not-allowed" : "pointer",
        background: checked ? "#198754" : "#ccc",
        opacity: disabled ? 0.6 : 1,
        transition: "background 0.15s ease-in-out",
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: "2px",
          left: checked ? "20px" : "2px",
          width: "18px",
          height: "18px",
          borderRadius: "50%",
          background: "white",
          transition: "left 0.15s ease-in-out",
        }}
      />
    </button>
  );
}
